import React from 'react';

import sgsLogo from '../images/logos/sgs.svg';
import dekraLogo from '../images/logos/dekra.svg';
import pointcodeLogoPng from '../images/logos/pointcode.png';
import codengoLogoPng from '../images/logos/codengo-compact.png';
import laposteLogoPng from '../images/logos/laposte.png';
import exacodeLogo from '../images/logos/exacode.svg';
import franceCodeLogo from '../images/logos/france-code.png';

const LOGOS = {
  CODENGO: codengoLogoPng,
  SGS: sgsLogo,
  DEKRA: dekraLogo,
  POINTCODE: pointcodeLogoPng,
  LAPOSTE: laposteLogoPng,
  EXACODE: exacodeLogo,
  FRANCECODE: franceCodeLogo,
};

const getLogo = (type) => {
  const singleWordType = type.replace(/ /g, '').toUpperCase();

  if (singleWordType) {
    return (
      <img src={LOGOS[singleWordType]} alt={`${singleWordType} logo`} />
    );
  }

  return null;
};

export const ExamCentersLogoService = {
  getLogo,
};
